import React, { Dispatch, useCallback, useEffect, useState } from 'react';
import { Tabs, Tab, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import instance from '../../../api/api';
import StoryLaunchPad from '../../../components/story/story-launchpad.component';
import EditedStories from '../../../components/story/to-do/unpublished.component';
import Help from '../../../components/_helper/help.component';
import IPage from '../../../interfaces/page';
import { IStory } from '../../../interfaces/story';
import { setCurrentPage } from '../../../store/actionCreators';
import { useTranslation } from "react-i18next";

type RouteParams = {
    page: string
}

/**
 * Create story page
 *
 * @param props : props
 * @returns void
 */
const LaunchPad: React.FunctionComponent<IPage> = props => {

    const dispatch: Dispatch<any> = useDispatch();
    const setPageName = useCallback((currentPage: string) => dispatch(setCurrentPage(currentPage)), [dispatch]);

    const [ loaded, setLoaded ] = useState<boolean>(false);
    const [inProgressStories, setInProgressStories] = useState<IStory[]>([]);

    //Tabs
    const params = useParams<RouteParams>();
    const navigate = useNavigate();

    const { t } = useTranslation();    

    useEffect(() => {
        setPageName(t("Creation"));
        getInProgressStories();
    }, []);

    async function getInProgressStories() {
        try {
            //Get edited stories
            const editedResponse = await instance.get('/stories?edited=true&published=true');
            const editedData: IStory[] = editedResponse.data;

            //Get unpunlished stories
            const unpublishedResponse = await instance.get('/stories?published=false');
            const unpublishedData: IStory[] = unpublishedResponse.data;

            //Concat them
            const result = editedData.concat(unpublishedData);
            setInProgressStories(result);
            setLoaded(true);
            if(result.length === 0) {
                navigate('/dashboard/create');          
            }
        }
        catch (error) {
            console.log('Error', error)
            setLoaded(true);
        }
    }

    function handleRouteChange(route: string) {
        route==="1" ? navigate('/dashboard/create') :  navigate("/dashboard/launchpad/" + route);
    }

    return (
        <div className="create-container">
            {!loaded ?
                <div className="spinner-container">
                    <Spinner animation="border" variant="#fff" />
                </div>
            :
            <div>
                <StoryLaunchPad />
                <EditedStories data={inProgressStories} loaded={loaded} />
                <Help category={"PUBLISHING"} pageName={`Launchpad`}></Help>                    
                {/*<Help category={"PUBLISHING"} pageName={"In Progress"}></Help>*/}
            </div>
            }
        </div>
    );
};

export default LaunchPad;
